import React, { useEffect, useState } from "react";
import { Box, Button, Grid2, Skeleton, Stack, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { asyncSearchList } from "../../../../../utils/httpRequests";
import { isArray } from "lodash";
import { useAlertContext } from "../../../../../contexts/alert/AlertProvider";
import { useRestaurantContext } from "../../../RestaurantPage";
import { updateTables } from "../../../../../redux/reducers/restaurant.reducer";

interface ITables {
  height: string;
}

function Tables({ height }: ITables) {
  const token = useSelector((state: any) => state.auth.token);
  const { currentStore } = useSelector((state: any) => state.config);
  const app = useSelector((state: any) => state.app.data);
  const { tables, currentHd } = useSelector((state: any) => state.restaurant);
  const { showAlert } = useAlertContext();
  const { selectTable } = useRestaurantContext();
  const [loading, setLoading] = useState<boolean>(false);

  const dispatch = useDispatch();

  const getTables = async () => {
    if (loading) return;
    setLoading(true);
    const resp = await asyncSearchList({
      apiCode: "dmban",
      idApp: app?._id,
      token,
      condition: {
        page: 1,
        limit: 999999,
        q: { ma_kho: currentStore?.ma_kho },
      },
    });
    if (!resp || resp?.status !== 200) {
      showAlert({
        type: "error",
        message:
          resp?.data?.error ||
          resp?.data?.message ||
          "Lỗi khi tải danh sách bàn",
      });
    } else {
      const data = resp?.data || [];
      data.sort((a: any, b: any) => Number(a.ma_ban) - Number(b.ma_ban));
      dispatch(updateTables(data));
    }
    setLoading(false);
  };

  const handleSelectTable = async (table: any) => {
    selectTable(table);
  };

  useEffect(() => {
    if (currentStore?.ma_kho) {
      getTables();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStore?.ma_kho]);

  return (
    <Box sx={{ width: "100%", height, p: 1 }}>
      {loading ? (
        <>
          <Grid2 container spacing={1} sx={{ pt: 1 }}>
            {new Array(10).fill(0).map((_, index) => {
              return (
                <Grid2 key={index} size={{ xs: 6, sm: 4, md: 3, lg: 2.4 }}>
                  <Skeleton
                    variant="rounded"
                    animation="wave"
                    sx={{ width: "100%", height: "70px" }}
                  />
                </Grid2>
              );
            })}
          </Grid2>
        </>
      ) : (
        <>
          {!currentStore ? (
            <Typography sx={{ textAlign: "center", fontSize: "18px" }}>
              Chọn chi nhánh để xem bàn
            </Typography>
          ) : (
            <Stack sx={{ height: "calc(100% - 16px)", overflow: "auto" }}>
              {isArray(tables) && tables.length > 0 ? (
                <>
                  <Grid2 container spacing={1}>
                    {tables.map((table: any) => {
                      const isActive = table?.ma_ban === currentHd?.ma_ban;
                      return (
                        <Grid2
                          key={table._id}
                          size={{ xs: 6, sm: 4, md: 3, lg: 2.4 }}
                        >
                          <Button
                            onClick={() => handleSelectTable(table)}
                            variant="contained"
                            sx={{
                              width: "100%",
                              boxShadow: "none",
                              backgroundColor: isActive
                                ? "primary.main"
                                : "background.default",
                              textTransform: "none",
                              fontWeight: 400,
                              minHeight: "80px",
                              "&:hover": {
                                backgroundColor: isActive
                                  ? "primary.main"
                                  : "primary.500",
                                boxShadow: "none",
                              },
                            }}
                          >
                            <Stack
                              direction="row"
                              alignItems="center"
                              justifyContent="center"
                              sx={{
                                backgroundColor: "background.paper",
                                width: "40px",
                                height: "40px",
                                borderRadius: "50%",
                                fontSize: "20px",
                              }}
                            >
                              {table.ten_ban}
                            </Stack>
                          </Button>
                        </Grid2>
                      );
                    })}
                  </Grid2>
                </>
              ) : (
                <Typography sx={{ textAlign: "center" }}>
                  Chi nhánh '{currentStore?.ten_kho}' chưa có bàn
                </Typography>
              )}
            </Stack>
          )}
        </>
      )}
    </Box>
  );
}

export default Tables;
